import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import * as classes from './ParametersTab.module.css';

const ParametersTab = ({
    ...props
}) => {

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <div className={classes.ParametersTab}>
            <div className={classes.LeftPanel}>
                <div className={classes.Title}>
                    Properties
                </div>
                <div className={classes.TopPanel}>
                    <div style={{ paddingBottom: '1.5rem', width: '100%'}}>
                        <FormControl
                            size="small"
                            className={classes.RuleName}
                        >
                            <TextField
                                size="small"
                                variant="outlined"
                                id="name"
                                name="name"
                                type="text"
                                value={''}
                                label={'Rule Name'}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                inputProps={{ maxLength: 250 }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.RulePriority}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Rule Priority
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    High
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ paddingBottom: '1.5rem', width: '100%'}}>
                        <FormControl
                            size="small"
                            className={classes.userInputWrapper}
                            style={{ width: '100%' }}
                        >
                            <TextField
                                size="small"
                                variant="outlined"
                                id="name"
                                multiline
                                rows={4}
                                name="name"
                                type="text"
                                value={''}
                                label={'Description'}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                inputProps={{ maxLength: 250 }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                    <div style={{ paddingBottom: '1.5rem', width: '100%'}}>
                        <FormControl
                            size="small"
                            className={classes.userInputWrapper}
                            style={{ width: '100%' }}
                        >
                            <TextField
                                size="small"
                                variant="outlined"
                                id="name"
                                multiline
                                rows={4}
                                name="name"
                                type="text"
                                value={''}
                                label={'System Effect'}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                inputProps={{ maxLength: 250 }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                    <div style={{ paddingBottom: '1.5rem', width: '100%'}}>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.IssueType}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Issue Type
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Type 1
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className={classes.BottomPanel}>
                    <div className={classes.Title}>
                        Service
                    </div>
                    <div style={{ paddingBottom: '1.5rem', width: '100%' }}>
                        <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.SkillType}
                        >
                            <InputLabel
                                htmlFor="templateName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Skill Type
                            </InputLabel>
                            <Select
                                value={0}
                                id="type"
                                MenuProps={MenuProps}
                                name="type"
                                classes={{
                                    root: classes.input
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                >
                                    Analog
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ paddingBottom: '1.5rem', width: '100%' }}>
                        <FormControl
                            size="small"
                            className={classes.userInputWrapper}
                            style={{ width: '100%' }}
                        >
                            <TextField
                                size="small"
                                variant="outlined"
                                id="name"
                                name="name"
                                type="text"
                                multiline
                                rows={4}
                                value={''}
                                label={'Recommendation'}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                inputProps={{ maxLength: 250 }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={classes.RightPanel} />
        </div>
    );
};

export default ParametersTab;
